module.exports = __webpack_public_path__ + "img/logo.727737da.png";